// Angular
import { Component } from '@angular/core';
// Service
import { ImportOrderService } from '../import-order/service/import-order.service';
import { CreateOrderService } from './service/create-order.service';
import { BroadcastService, ToasterType, CONTENT_LOADER_EVENT } from '@cv-invision/core';
// Model
import { CreateOrderFormModel } from './model/create-order-form.model';
// Other
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

@Component({
	selector: 'cv-create-order',
	templateUrl: './create-order.component.html',
	styleUrls: ['./create-order.component.scss']
})
export class CreateOrderComponent {
	public createOrderForm: CreateOrderFormModel = {
		form: null,
		file: null
	};
	public formList$: Observable<any>;
	public filesDropMessage = 'Upload a MISMO XML file to create a QC Order.';

	constructor(
		private importOrderService: ImportOrderService,
		private createOrderService: CreateOrderService,
		private store: Store,
		private broadcastService: BroadcastService,
		private router: Router
	) {
		this.getData();
	}

	/**
	 * Prepare the data that will be used of the Import Dropdowns
	 */
	public getData(): void {
		this.formList$ = this.importOrderService.getForms();
	}

	/**
	 * CC the value when selecting the Form
	 * @param form
	 */
	public onFormSelectChange(form: any): void {
		this.createOrderForm.form = form;
	}

	/**
	 * Get the latest file Uploaded
	 * @param event
	 */
	public onFilesDropped(event: any): void {
		this.createOrderForm.file = event[0];
	}

	/**
	 * Create the New Order
	 */
	public onSubmitOrder(): void {
		this.showLoader(true);
		this.createOrderService.createOrder(this.createOrderForm).subscribe(
			(res: any) => {
				this.showLoader(false);
				this.router.navigate(['/intelligence/quality/overview', res.orderId]);
				setTimeout(() => {
					this.broadcastService.broadcast({
						name: ToasterType.SUCCESS,
						event: {
							message:
								'Order Successfully Created: <span class="order-id">' + res.orderId + '</span>'
						}
					});
				}, 100);
			},
			error => {
				this.showLoader(false);
			}
		);
	}

	/**
	 * Show/Hide the Loader
	 * @param isShowing
	 */
	private showLoader(isShowing: boolean): void {
		this.broadcastService.broadcast({
			name: CONTENT_LOADER_EVENT,
			event: {
				isLoader: isShowing,
				message: 'Submitting Order'
			}
		});
	}
}
